import React, { memo } from 'react';
import { obtenerDataImagen } from '../../actions/ImagenAction';
import { CustomButton } from './CustomButton';
import toast from 'react-hot-toast';

const CustomButtonAdjuntar = memo(({
    customButtonProps,
    maxFileSize = 8,
    validExtensions = ['PDF', 'PNG', 'JPG', 'JPEG'],
    onAddFile
}) => {

    const onClickAdjuntar = async ({ target: { files } }) => {
        try {
            const file = files[0];
            const { name, size } = file;
            const fileExtension = name.split('.').pop();
            const fileSizeToMB = (size / (1024 * 1024))?.toFixed(2);
            const fileNameIsValid = !(new RegExp(/[&\#,+$~^%|\/":?<>{}]/g).test(name));

            if (fileSizeToMB > maxFileSize) {
                throw (`Limite de tamaño alcanzado. (Max ${maxFileSize}MB)`);
            }
            if (!validExtensions?.includes(fileExtension?.toUpperCase())) {
                throw ('Extensión de archivo invalida.');
            }
            if (!fileNameIsValid) {
                throw ('Nombre del archivo no valido');
            }

            var fileData = await obtenerDataImagen(file);

            const parsedFile = {
                contentType: fileData?.tipo,
                archivo: fileData?.data,
                extension: fileData?.extension,
                titulo: fileData?.nombre
            };

            onAddFile(parsedFile);

        } catch (error) {
            toast.error(typeof error === 'string' ? error : 'Se produjo un error al intentar agregar el documento')
        }
    }

    return (
        <CustomButton
            {...customButtonProps}

            onClick={() => { }}
        >
            <input
                type='file'
                hidden
                onClick={(e) => (e.target.value = '')}
                onChange={e => onClickAdjuntar(e)}
            />
            Adjuntar
        </CustomButton>
    )
});


export default CustomButtonAdjuntar; 